import { useState } from 'react';

import { toCurrency } from '@Helpers';

import { Offer } from '@App/interfaces/offer';
import { ProductCardFeatures } from '@Components/ProductCardFeatures/ProductCardFeatures';
import { RateCardDetails } from '@Components/RateCard/RateCardDetails';

import ChevronIcon from '../Icons/Chevron';
import RadioSelected from '../Icons/RadioSelected';
import RadioUnselected from '../Icons/RadioUnselected';

interface RateCardProps {
    offer: Offer;
    selectable?: boolean;
    selected: boolean;
    onSelect?: () => void;
}

const RateCard = ({ offer, onSelect, selectable, selected }: RateCardProps) => {
    const [showMoreInfo, setShowMoreInfo] = useState(false);

    const title = offer.isVariable ? 'Variable rate' : 'Fixed rate';

    const renderButton = (isSelected: boolean, size?: number) => {
        return isSelected ? (
            <RadioSelected size={size} />
        ) : (
            <RadioUnselected onClick={onSelect} size={size} />
        );
    };

    const handleToggle = () => {
        setShowMoreInfo((prev) => !prev);
    };

    return (
        <div
            className={`mb-4 py-3 px-6 rounded-t-2xl rounded-bl-2xl rounded-br w-full max-w-330 lg:max-w-none lg:mr-6 flex flex-col pt-6 bg-almond-200 ${
                selected
                    ? 'shadow-offerSelected border-b-4 border-midnight-500'
                    : 'shadow-offer'
            }`}
        >
            <div className='flex flex-col grow'>
                <div
                    onClick={() => selectable && onSelect?.()}
                    className='cursor-pointer'
                >
                    <div className='flex justify-between items-center pb-4'>
                        <div className='leading-120%'>
                            <span className='text-28 font-sora-bold'>
                                {title}
                            </span>
                            <div className='flex text-lg'>
                                <p>{`£${toCurrency(offer.initialPayment)}`}</p>
                                <span>/month</span>
                            </div>
                        </div>
                        {selectable && renderButton(selected)}
                    </div>
                    <ProductCardFeatures offer={offer} />

                    {showMoreInfo && <RateCardDetails offer={offer} />}
                </div>
            </div>

            <div
                onClick={handleToggle}
                className='w-24 text-xs my-4 font-bold justify-center bg-midnight-500 text-monochrome-100 items-center flex rounded-2xl cursor-pointer'
            >
                <span className='pr-1'>{`Show ${
                    !showMoreInfo ? 'more' : 'less'
                }`}</span>
                <ChevronIcon
                    isRotated={showMoreInfo}
                    height='12px'
                    width='12px'
                    color='white'
                />
            </div>
        </div>
    );
};

export default RateCard;
